jQuery(document).ready(function() {
	//#################################################################################################### Handling vintage collections selector changes
	jQuery(document).on('change', '.vintage-dropdown select', function(event) {
		window.location.href = this.value;
	});
	//#################################################################################################### Handling fake anchors on storytelling collections
	jQuery(document).on('click', 'a.btn[href="#go-to-products"]', function(event) {
		event.preventDefault();
		let sectionId = 'shopify-section-template--16609348190437__7aa1bb75-6f6c-41c6-a236-2a5f5dac006e';
		jQuery([document.documentElement, document.body]).animate({ scrollTop: (jQuery(`#${sectionId}`).offset().top - 45)}, 600);
	});
	//#################################################################################################### Handling fake links
	jQuery(document).on('click', 'a[href="#nolink"]', function(event) {
		event.preventDefault();
	});
	//#################################################################################################### Moving wine custom label block
	let wineCustomLabelBlockSelector = jQuery('#shopify-section-template--16578668691685__1666275427dba5a373');
	if((typeof(wineCustomLabelBlockSelector) != 'undefined') && (wineCustomLabelBlockSelector.length != 0)) {
		let priceBlock = jQuery('.product-single__meta .product-block--price');
		if((typeof(priceBlock) != 'undefined') && (priceBlock.length != 0)) {
			priceBlock = priceBlock.first();
			let wineCustomLabelBlock = wineCustomLabelBlockSelector.detach();
			priceBlock.before(wineCustomLabelBlock);
		}
	}
});
